module.exports = __webpack_public_path__ + "static/media/WhatsApp Video 2026-03-02 at 12.49.10 PM.be05e22f.mp4";